import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const AwardsAndRecognitionsRepository = {
  saveAwardsAndRecognitionsData: (vacId, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/awards`,
      method: "POST",
      data: data,
    });
  },
  getAwardsAndRecognitionsData: (vacId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/awards`,
      method: "GET",
    });
  },
  getAllTypes: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}awardTypes`,
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllRecognitionCarriers: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}awardRecognitionCarriers`,
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllLevels: (gradingSchemaId, carrierId) => {
    return Axios({
      url: `${SETTINGS.API_URL}awardLevels`,
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId, carrierId: carrierId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  updatePoints: (id, points) => {
    return Axios({
      url: `${SETTINGS.API_URL}awardRecognition/${id}/points`,
      params: { points: points },
      method: "PUT",
    });
  },

  unlockPoints: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}awardRecognition/${id}/unlockPoints`,
      method: "PUT",
    });
  },

  setComment: (id, comment) => {
    return Axios({
      url: `${SETTINGS.API_URL}awardRecognition/${id}/comment`,
      params: { comment: comment },
      method: "PUT",
    });
  },
};
